import React from 'react';
import styles from './TextWithEllipsis.scss';

export const TextWithEllipsis = ({ text }: { text: string }) => (
  <div title={text} className={styles.textWrapper}>
    {text}
  </div>
);
